module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('h2', {
    staticClass: "h2"
  }, [_c('a', {
    attrs: {
      "id": "ch12"
    }
  }), _c('a', {
    attrs: {
      "id": "page_13"
    }
  }), _c('a', {
    attrs: {
      "href": "#/contents#ch12"
    }
  }, [_c('b', [_vm._v("Random Thirteens")])])]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_c('span', [_vm._v("The number 13 is considered lucky in China because its symbol resembles one that means “must be alive.”")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_c('span', [_vm._v("In 1941, Joe DiMaggio struck out only 13 times. (In contrast, Phillies first baseman Ryan Howard struck out 199 times in 2007, the most on record.)")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_c('span', [_vm._v("Napoléon Bonaparte, Herbert Hoover, and Franklin Delano Roosevelt all feared the number 13.")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_c('span', [_vm._v("In 1959, Harvey Haddix became the first pitcher to throw 12 perfect innings—and then he lost the game in the 13th.")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_c('span', [_c('i', [_vm._v("Apollo 13")]), _vm._v(" was launched at 13:13, military time. The astronauts aborted the mission and turned back to Earth on Friday, April 13.")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_c('span', [_vm._v("Black Sabbath released its self-titled first album in February 1970…on Friday the 13th.")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_c('span', [_vm._v("Cost to U.S. economy when superstitious people stay home on Friday the 13th: $800 million.")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_c('span', [_vm._v("Although DVDs are the same size as CDs, a DVD can store 13 times as much data.")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-b74940ae","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/chapter12.vue
// module id = 108
// module chunks = 0